<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>QUALIFICATION DE LA DEMANDE</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="$emit('closeSidebar')"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <form>
          <template>
            <p class="mt-5">Client <b style="color: #ff6141">*</b></p>
            <vs-select
              class="w-full"
              v-model="form.customer_id"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.social_reason"
                v-for="(item, index) in customers"
              />
            </vs-select>
          </template>

          <p class="mt-5">
            Titre de la demande <b style="color: #ff6141">*</b>
          </p>
          <vs-input
            v-on:keydown.enter.prevent="keyEvent($event)"
            v-model="form.title"
            class="w-full"
            name="item-name"
          />

          <template v-if="!$store.state.is_commercial()">
            <p class="mt-5">Commercial <b style="color: #ff6141">*</b></p>
            <vs-select
              class="w-full"
              v-model="form.commercial_id"
              autocomplete
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.name"
                v-for="(item, index) in commerciaux"
              />
            </vs-select>
          </template>

          <p class="mt-5">Type de demande <b style="color: #ff6141">*</b></p>
          <vs-select

            class="w-full"
            v-model="form.type_request_id"
            autocomplete
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in categories_requests"
            />
          </vs-select>

          <p v-if="form.type_request_id" class="mt-5">
            Sous-type de demande <b style="color: #ff6141">*</b>
          </p>
          <vs-select
            v-if="form.type_request_id"
            class="w-full"
            v-model="form.subtype_request_id"
            autocomplete
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in sub_categories_requests"
            />
          </vs-select>

          <p class="mt-5">Priorité <b style="color: #ff6141">*</b></p>
          <vs-select class="w-full" autocomplete v-model="form.priority_id">
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in priorities"
            />
          </vs-select>

          <p class="mt-5">Votre demande<b style="color: #ff6141">*</b></p>
          <div>
            <p v-html="form.request_content"></p>
          </div>
        </form>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="qualifyRequest()" :disabled="!isFormValid"
        >Soumettre</vs-button
      >
      <vs-button type="border" color="danger" @click="$emit('closeSidebar')"
        >Annuler</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
let base_self;
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "qualifySidebar",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    qualifyCallBack: {
      type: Function,
    },
    getSubCategories: { type: Function },
    customers: { type: Array, required: true },
    categories_requests: { type: Array, required: true },
    sub_categories_requests: { type: Array, required: true },
    priorities: { type: Array, required: true },
    commerciaux: { type: Array, required: true },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
    },
    'form.type_request_id': (val, old_val) => {
      // console.log(val, old_val);
      if (old_val !== '' && old_val !== val) {
        base_self.form.subtype_request_id = '';
        base_self.getSubCategories(val)
      }
    }
  },
  data() {
    return {
      popupActive: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    isFormValid() {
      var is_valide = true;
      if (
        this.$store.state.is_chargerClientele() &&
        (!this.form.customer_id || this.form.customer_id === "")
      )
        is_valide = false;
      if (!this.form.title || this.form.title === "") is_valide = false;
      if (!this.form.type_request_id || this.form.type_request_id === "")
        is_valide = false;
      if (
        !this.form.subtype_request_id ||
        this.form.subtype_request_id === ""
      )
        is_valide = false;
      if (!this.form.priority_id || this.form.priority_id === "")
        is_valide = false;
      if (!this.form.request_content || this.form.request_content === "")
        is_valide = false;

      if (!this.form.commercial_id || this.form.commercial_id === "") {
        is_valide = false;
      }
      return is_valide;
    },
  },
  methods: {
    test(id){
      console.log(id);
    },
    keyEvent(event) {
      if (event) event.preventDefault();
    },
    qualifyRequest() {
      this.$vs.loading();
      this.$http
        .post("/requests/qualify", this.form)
        .then((response) => {
          this.$vs.loading.close();
          if (response.data.status == true) {
            this.$vs.notify({
              title: "Succès",
              text: "Opération effectuée avec succès",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$emit("closeSidebar");
            this.qualifyCallBack(true);
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error && error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        })
    },
  },
  mounted(){
    base_self = this;
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
